import React from "react";
import {useDispatch} from "react-redux";
import {menuActive, menuInactive} from "../menu/menu-slice";
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import "./header.scss"


const Header = () => {
    const {menuState} = useTypedSelector(state => state.menu)
    const dispatch = useDispatch()
    return (
        <section className={`header`}>
            <div className={"social-btn-group"}>
                <a
                    href={"https://hh.ru/employer/624705"}
                    target="_blank"
                    className={"link link-hh"}
                >head hunter link</a>
                {/*<a*/}

                {/*    href={"#"}*/}
                {/*    className={"link link-mob"}*/}
                {/*/>*/}
                <a
                    href={"https://t.me/relts"}
                    target="_blank"
                    className={"link link-tg"}
                >telegram link</a>
                <a
                    href={"https://wa.me/+79200526635"}
                    target="_blank"
                    className={"link link-wa"}
                >whats app link</a>
                {/*<a*/}
                {/*    href={"#"}*/}
                {/*    className={"link link-fb"}*/}
                {/*/>*/}
                {/*<a*/}
                {/*    href={"#"}*/}
                {/*    className={"link link-insta"}*/}
                {/*/>*/}
            </div>
            <a
                href={"tel: +74992383196"}
                target="_blank"
                className={"tel-number"}
            >+7 (499) 238 31 96</a>
            <button onClick={()=>{dispatch(menuState === "active" ? menuInactive() : menuActive())}} className={`btn menu-btn`}>Отркыть меню</button>
        </section>
    )
}

export default Header